// extracted by mini-css-extract-plugin
export default {"editingInputPartialInputText":"EditingInput_editingInputPartialInputText__k-ZfY"};